import { ValidationType } from '../../../utilitity/validation';
import Translation from '../../../../Shared/components/Translation';
import React from 'react';
export const Validation = ({ field }) => {
    switch (field.validation) {
        case ValidationType.IBAN:
            return (React.createElement("span", { slot: "validation-message", "data-reason": "invalidIban" },
                React.createElement(Translation, { item: "powermail.error.invalidIban" })));
        case ValidationType.DUTCH_PHONE:
            return (React.createElement("span", { slot: "validation-message", "data-reason": "invalidDutchPhone" },
                React.createElement(Translation, { item: "powermail.error.invalidDutchPhone" })));
        case ValidationType.POSTAL_CODE:
            return (React.createElement("span", { slot: "validation-message", "data-reason": "invalidPostalCode" },
                React.createElement(Translation, { item: "powermail.error.invalidPostalCode" })));
        case ValidationType.EMAIL:
            return (React.createElement("span", { slot: "validation-message", "data-reason": "invalidEmail" },
                React.createElement(Translation, { item: "powermail.error.invalidEmail" })));
        case ValidationType.PHONE:
            return (React.createElement("span", { slot: "validation-message", "data-reason": "invalidPhone" },
                React.createElement(Translation, { item: "powermail.error.invalidPhone" })));
        case ValidationType.DIGITS:
            return (React.createElement("span", { slot: "validation-message", "data-reason": "invalidDigits" },
                React.createElement(Translation, { item: "powermail.error.invalidDigits" })));
        case ValidationType.LETTERS:
            return (React.createElement("span", { slot: "validation-message", "data-reason": "invalidLetters" },
                React.createElement(Translation, { item: "powermail.error.invalidLetters" })));
        default:
            return null;
    }
};
